import { Button } from "ellow-web-ui-components-library";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Modal from "../../components/modal";
import { clientId, templateIds } from "../../utils/CONSTANTS";
import { getMilliSecUTC  } from "../../utils/EllowUtils"
import { FormInput } from "../../wrappers/formInput";
import { DropboxPreview, getCustomFields, saveSignatureId , getSignatureId } from "./services";
import Styles from "./styles.module.scss";
import HelloSign from "hellosign-embedded";
import { DropDownInput } from "../../wrappers/selectInput";

export type agreementForm = {
  addressLine1: string;
  addressLine2: string;
  addressLine3: string;
  addressLine4: string;
  addressLine5: string;
  addressLine6: string;
  annualSalary: number;
  currencyType: string;
};

interface props {
  onClose: any;
  defaultValues: any;
  agreementValues: any;
}

const ContractAgreement: React.FC<props> = ({
  onClose,
  defaultValues,
  agreementValues,
}) => {
  const formOptions = {};

  const { register, handleSubmit, control, reset } =
    useForm<agreementForm>(formOptions);

  const [signatureRequestId, setSignatureRequestId] = useState<string>('')
  const [disabled, setDisabled] = useState<boolean>(true)
 
  useEffect(() => {
    
    getAgreementData()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [agreementValues.prevCandidateJobId])
  
  const getAgreementData = () => {
    getCustomFields(agreementValues && agreementValues.prevCandidateJobId).then((response: any) => {
      reset(response)
    })
  }

  const onPreview = (data: any) => {
    
      let payload = {
        "client_id": clientId,
        "template_ids": templateIds,
        "subject": "Emmeded Test CAL",
        "message": "Glad we could come to an agreement.",
        "signing_redirect_url": 'myworkplace.ellow.io/dashboard',
        "metadata" : {
          "candidateJobId": agreementValues && agreementValues.candidateJobId,
          "action": agreementValues && agreementValues.action,
          "version": agreementValues && agreementValues.version,
          "ENV": 'DEV',
          "startDate": agreementValues && agreementValues.startDate,
          "endDate": agreementValues && agreementValues.endDate,
          "revised": agreementValues.revised,
          "fileType": 'CAL'
        },
        "signers": [
          {
            "role": "Client",
            "name": agreementValues && agreementValues.candidateName,
            "email_address": agreementValues && agreementValues.candidateEmail
            // "name": 'Jithin U S',
            // "email_address": 'jithin.us@ellow.io'
          }
        ],
        "custom_fields": [
                          {
                              "name": "currentDateField",
                              "type": "text",
                              "required": false,
                              "value": new Date().toDateString().slice(3)
                          },
                          {
                              "name": "AddressLine1Field",
                              "type": "text",
                              "required": false,
                              "value": data.addressLine1
                          },
                          {
                              "name": "AddressLine2Field",
                              "type": "text",
                              "required": false,
                              "value": data.addressLine2
                          },
                          {
                              "name": "AddressLine3Field",
                              "type": "text",
                              "required": false,
                              "value": data.addressLine3
                          },
                          {
                              "name": "AddressLine4Field",
                              "type": "text",
                              "required": false,
                              "value": data.addressLine4
                          },
                          {
                              "name": "AddressLine5Field",
                              "type": "text",
                              "required": false,
                              "value": data.addressLine5
                          },
                          {
                              "name": "AddressLine6Field",
                              "type": "text",
                              "required": false,
                              "value": data.addressLine6
                          },
                          {
                              "name": "candidateNameField",
                              "type": "text",
                              "required": false,
                              "value": agreementValues && agreementValues.candidateName
                          },
                          {
                              "name": "positionField",
                              "type": "text",
                              "required": false,
                              "value": agreementValues && agreementValues.candidateRole
                          },
                          {
                              "name": "contractStartDateField",
                              "type": "text",
                              "required": false,
                              "value": agreementValues && agreementValues.startDate && new Date(agreementValues.startDate).toDateString().slice(3)
                          },
                          {
                              "name": "contractDateField",
                              "type": "text",
                              "required": false,
                              "value": `${agreementValues && agreementValues.startDate && new Date(agreementValues.startDate).toDateString().slice(3)} to ${agreementValues && agreementValues.endDate && new Date(agreementValues.endDate).toDateString().slice(3)}`
                          },
                          {
                              "name": "contractRateField",
                              "type": "text",
                              "required": false,
                              "value": data && data.annualSalary
                          },
                          {
                              "name": "grossAanualAmountField",
                              "type": "text",
                              "required": false,
                              "value": data.annualSalary
                          },
                          {
                              "name": "grossMonthlyAmountField",
                              "type": "text",
                              "required": false,
                              "value": data.annualSalary / 12
                          },
                    
                          {
                              "name": "candidateNameField",
                              "type": "text",
                              "required": false,
                              "value": agreementValues && agreementValues.candidateName
                          }
                      ],
        "signing_options": {
          "draw": true,
          "type": true,
          "upload": true,
          "phone": false,
          "default_type": "draw"
        },
        "requester_email_address": "sariga@ellow.io",
        "is_for_embedded_signing": true,
        "preview_only": true,
        // "test_mode": false
    }
    
    DropboxPreview(payload).then((response: any) => {
      if(response){
        setSignatureRequestId(response.unclaimed_draft.signature_request_id)
        const client = new HelloSign({
          clientId: clientId,
        })
        client.open(response.unclaimed_draft.claim_url, {
        })
        setDisabled(false)
      }
    })
  }
    
    const onSubmit = (data: any) => {

      getSignatureId(signatureRequestId).then((response: any) => {
        if(response){
          let value = {
            "loginId": agreementValues && agreementValues.candidateId,
            "candidateJobId": agreementValues && agreementValues.candidateJobId,
            "candidateName": agreementValues && agreementValues.candidateName,
            "candidateEmail": agreementValues && agreementValues.candidateEmail,
            "signature_id": response.signature_request.signatures[0].signature_id,
            "companyName": agreementValues && agreementValues.companyName,
            "position": agreementValues && agreementValues.candidateRole,
            "startDate": agreementValues && agreementValues.startDate,
            "contractInitiatedDate": getMilliSecUTC(new Date()),
            "customFields": {
              "addressLine1": data.addressLine1,
              "addressLine2": data.addressLine2,
              "addressLine3": data.addressLine3,
              "addressLine4": data.addressLine4,
              "addressLine5": data.addressLine5,
              "addressLine6": data.addressLine6,
              "annualSalary": data.annualSalary,
              "currencyType": data.currencyType
            }
          }
          saveSignatureId(value).then((response: any) => {
            if (response && response.status === 1) {
              onClose('true')
            }
          })
        }
      })
    }

  return (
    <>
      <Modal title={"Contract Agreement "} size="medium" onClose={onClose}>
        <form>
          <label className="lablel">Candidate address:</label>
          <div className="half-form-wrap">
            <div className="form-group">
              <FormInput<agreementForm>
                name="addressLine1"
                type="text"
                placeholder="addressLine 1"
                register={register}
              />
            </div>
            <div className="form-group">
              <FormInput<agreementForm>
                name="addressLine2"
                type="text"
                placeholder="adressLine2"
                register={register}
              />
            </div>
          </div>
          <div className="half-form-wrap">
            <div className="form-group">
              <FormInput<agreementForm>
                name="addressLine3"
                type="text"
                placeholder="adressLine3"
                register={register}
              />
            </div>
            <div className="form-group">
              <FormInput<agreementForm>
                name="addressLine4"
                type="text"
                placeholder="adressLine4"
                register={register}
              />
            </div>
          </div>
          <div className="half-form-wrap">
            <div className="form-group">
              <FormInput<agreementForm>
                name="addressLine5"
                type="text"
                placeholder="adressLine5"
                register={register}
              />
            </div>
            <div className="form-group">
              <FormInput<agreementForm>
                name="addressLine6"
                type="text"
                placeholder="adressLine 6"
                register={register}
              />
            </div>
          </div>
          <div className={Styles.basicInfoCard}>
            <div className={Styles.cardItrem}>
              <div className={Styles.form}>
                <label>Candidate name:</label>
                {agreementValues && agreementValues.candidateName}
              </div>
              <div className={Styles.form}>
                <label>Company name:</label>
                {agreementValues && agreementValues.companyName}
              </div>
              <div className={Styles.form}>
                <label>Start date:</label>
                {agreementValues && agreementValues.startDate && new Date(agreementValues.startDate).toDateString().slice(3)}
              </div>
              
            </div>
            <div className={Styles.cardItrem}>
              <div className={Styles.form}>
                <label>Candidate role:</label>
                {agreementValues && agreementValues.candidateRole}
              </div>
              <div className={Styles.form}>
                <label>End date:</label>
                {agreementValues && agreementValues.endDate && new Date(agreementValues.endDate).toDateString().slice(3)}
              </div>
              <div className={Styles.form}>
                <label>Monthly salary:</label>
                {agreementValues && agreementValues.monthlySalary}
              </div>
                      </div>
                      <div className="form-group">
                <label className="lablel">Annual salary:</label>
                <FormInput<agreementForm>
                  name="annualSalary"
                  type="number"
                  placeholder={"Annual Salary"}
                  register={register}
                />
            </div>
            <div className="form-group">
                <label className="lablel">Currency type:</label>
                <DropDownInput<agreementForm>
                  name="currencyType"
                  register={register}
                  control={control}
                  data={['INR', 'USD']}
                />
              </div>
          </div>
          <div className="popupAction">
            <Button variant="primary" onClick={handleSubmit(onPreview)}>
              Preview
            </Button>
            <Button variant="secondary" onClick={onClose}>
              Cancel
            </Button>
            <Button variant="primary" disabled={disabled} onClick={handleSubmit(onSubmit)}>
              Done
            </Button>
          </div>
        </form>
      </Modal>
    </>
  );
};

export default ContractAgreement;
